import { urlUtil } from '@cmg/common';

import { useOfferingSidePanelSearch } from '../../../hooks/useOfferingSidePanelMatch';
import { NotesFilters } from '../NotesModel.util';

export type NoteSearchParams = {
  noteType: NotesFilters;
  cmgEntityKey?: string;
};

export const useNoteSearchParams = (defaultValue: NoteSearchParams): NoteSearchParams => {
  const search = useOfferingSidePanelSearch();
  const { noteType, cmgEntityKey } = urlUtil.queryParse<{
    noteType: NotesFilters;
    cmgEntityKey: string;
  }>(search);

  const isNoteTypeValid = Object.values(NotesFilters).includes(noteType);

  return {
    cmgEntityKey: cmgEntityKey ?? defaultValue.cmgEntityKey,
    noteType: isNoteTypeValid ? noteType : defaultValue.noteType,
  };
};
